import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

const PLAY_STORE_URL = 'https://play.google.com/store/apps/details?id=com.astralight.xyz&hl=fr';

const Footer = () => {
    return (
        <footer className="footer sky">
            <div className="container section">
                <div className="footer-row">
                    <div className="footer-col footer-brand">
                        <img src="/logo_light.webp" alt="AstraLight" className="footer-logo" />
                        <p className="footer-tagline">
                            Synastrie, thème astral et horoscope : des outils d'astrologie
                            gratuits, calculés sur les positions réelles des planètes.
                        </p>
                        <p className="footer-contact-line">
                            <i className="fa-regular fa-envelope" aria-hidden="true"></i>{' '}
                            <a href="mailto:contact@astralight.xyz">contact@astralight.xyz</a>
                        </p>
                    </div>

                    <div className="footer-col">
                        <h3>Outils gratuits</h3>
                        <ul>
                            <li><Link to="/compatibilite-amoureuse-astrologie">Synastrie de couple</Link></li>
                            <li><Link to="/calcul-theme-astral">Calcul du thème astral</Link></li>
                            <li><Link to="/horoscope-hebdomadaire">Horoscope hebdomadaire</Link></li>
                            <li><Link to="/blog">Blog astrologique</Link></li>
                        </ul>
                    </div>

                    <div className="footer-col">
                        <h3>Apprendre l'astrologie</h3>
                        <ul>
                            <li><Link to="/blog/planetes/venus">Vénus et l'amour</Link></li>
                            <li><Link to="/blog/planetes/lune">La Lune et les émotions</Link></li>
                            <li><Link to="/blog/signes/belier">Les 12 signes du zodiaque</Link></li>
                            <li><Link to="/blog/maisons/maison-7">La maison 7, celle du couple</Link></li>
                        </ul>
                    </div>

                    <div className="footer-col footer-app">
                        <h3>L'application Android</h3>
                        <p>
                            Vos profils, vos synastries et votre horoscope personnalisé,
                            toujours dans votre poche.
                        </p>
                        <a
                            href={PLAY_STORE_URL}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="footer-play-link"
                            aria-label="Télécharger Astralight sur Google Play"
                        >
                            <i className="fa-brands fa-google-play" aria-hidden="true"></i>
                            <span>
                                <small>Disponible sur</small>
                                Google Play
                            </span>
                        </a>
                    </div>
                </div>
                <hr />
                <div className="footer-bottom">
                    <p>Copyright © {new Date().getFullYear()} AstraLight</p>
                    <p className="footer-attribution">
                        <a href="https://www.flaticon.com/packs/esoteric-11" title="esoteric icons">
                            Esoteric icons created by Freepik - Flaticon
                        </a>
                    </p>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
